module.exports = __webpack_public_path__ + "img/02web-you.64f48b0f.png";